import React from "react";
import {Col, Row, Typography} from "antd";
import { useTranslation } from "react-i18next";
import moment from "moment";
import {DATE_TIME_FORMAT} from "@config/constants";

const {Title, Text} = Typography;
const UpcomingBid = ({ product }) => {
  const { t } = useTranslation();
  return (
    <Row>
      <Col xs={24} md={24}>
        <Title level={5} className="page-block-product-upcoming-title">{t("product.will_start")}</Title>
        <Text className="page-block-product-upcoming-date">{moment(product?.start_time).format(DATE_TIME_FORMAT)}</Text>
      </Col>
    </Row>
  );
};

export default UpcomingBid;

